import React, {useState} from "react";
import styled from "styled-components";
import Select from "react-select";
import {useNavigate} from "react-router-dom";
import {reportTypeDropDownOptions} from "../../../../utils/const/reportConsts";
import {customTheme} from "../blueprint/BlueprintForm";
import {useController, useForm} from "react-hook-form";
import {useMutation} from "react-query";
import {sendReports} from "../../../../utils/const/query-key";
import apiService from "../../../../api/apiService";
import Loading from "../../Loading";
import MessageModal from "../../../common/MessageModal";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

const TopTitle = styled.div`
  display: flex;
`;

const TitleBackLocation = styled.div`
  color: black;
  cursor: pointer;
`;

const TitleCurrentLocation = styled.div`
  display: flex;
  color: var(--color-text-title);
`;

const FormWrapper = styled.div`
  padding: 30px 50px;
  background: var(--color-createenv-wrapper-bg-white) 0% 0% no-repeat padding-box;
  box-shadow: 0px 10px 20px var(--color-createenv-form-wrapper-box-shadow);
  opacity: 1;
  height: 100vh;

`
const Title = styled.div`
  text-align: left;
  margin: 25px 0;
  font: normal normal normal 24px/31px DIN Pro;
  color: var(--color-text-general);
  text-transform: capitalize;
  opacity: 1;
`;

const InputContainer = styled.div`
  margin: 15px;
  width: -webkit-fill-available;
  color: var(--color-form-font-description);

`;
const DatePickerContainer = styled.div`
  input {
    width: inherit;
    height: 36px;
    border: 1px solid var(--color-table-border-pageinput);
    padding: 4px;
    color: var(--color-form-font-description)
  }

  .react-datepicker-ignore-onclickoutside {
    outline-color: var(--color-brand-pink-primary);
  }

  .react-datepicker__day--selected,
  .react-datepicker__header,
  .react-datepicker__day--keyboard-selected {
    background-color: var(--color-table-filter-hover);
    color: var(--color-workspace-bg-page-area);
  }

  .react-datepicker__current-month,
  .react-datepicker__day-name,
  .react-datepicker__day {
    font-size: 13px !important;
    text-align: center;
  }

  .react-datepicker__day:hover,
  .react-datepicker__month-text:hover,
  .react-datepicker__quarter-text:hover,
  .react-datepicker__year-text:hover {
    background-color: var(--color-sidebar-pink-selected);
    transition: all 0.3s ease-in-out;
  }
`;

const Button = styled.button`
  height: 40px;
  width: 50%;
  border: 1px solid var(--color-createenv-form-btn-border);
  cursor: pointer;
  margin: 25px 15px;
  background-color: var(--color-brand-pink-primary);
  border-radius: 5px;
  color: var(--color-workspace-bg-page-area);

  &:hover {
    background-color: var(--color-createenv-stepper-next-btn-bg-hover);
  }
`;


const Reports = () => {
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);
    const [modal, setModal] = useState({});
    const oneWeekAgo = new Date();
    oneWeekAgo.setDate(oneWeekAgo.getDate() - 7);
    const currentDate = new Date();

    const {mutate, isLoading} = useMutation(sendReports,
        (request) => apiService.sendReport(request),
        {
            onSuccess: (status) => {
                let modalObject = {submit: "Ok", cancel: false};
                modalObject["message"] = status ? "Report was sent to your mail address." : "Unable to send report.\n Please try again later or contact Application Help Desk.";
                setModal(modalObject);
                setOpen(true);
            },
        });

    const initialReportForm = {
        reportType: "",
        fromDate: oneWeekAgo,
        toDate: currentDate,
    };
    const {register, control, handleSubmit} = useForm({defaultValues: initialReportForm});
    const {field: fieldReportType} = useController({name: 'reportType', control});
    const {field: fieldFromDate} = useController({name: 'fromDate', control});
    const {field: fieldToDate} = useController({name: 'toDate', control});

    const mySubmitHandler = (formValues) => {
        let requestObject = {...formValues};
        requestObject["fromDate"] = fieldFromDate.value.toISOString().slice(0, 10);
        requestObject["toDate"] = fieldToDate.value.toISOString().slice(0, 10);
        mutate(requestObject);
    }

    return (
        <div>
            <TopTitle>
                <TitleBackLocation onClick={() => navigate("/demo-point")}>Demo Point Home </TitleBackLocation>
                <TitleCurrentLocation>/ Admin Demo Point Reports</TitleCurrentLocation>
            </TopTitle>
            <FormWrapper>
                {isLoading && <Loading/>}
                {open && <MessageModal modal={modal} open={open} setOpen={setOpen}/>}
                <Title>Reports</Title>
                <form
                    onSubmit={handleSubmit(mySubmitHandler)}
                    autoComplete={"off"}>
                    <div style={{width: "50%"}}>
                        <InputContainer>
                            Report Type
                            <Select
                                {...register('reportType', {required: true})}
                                options={reportTypeDropDownOptions}
                                theme={customTheme}
                                placeholder={"Select"}
                                value={reportTypeDropDownOptions.find(({value}) => value === fieldReportType.value)}
                                onChange={(option) => {
                                    fieldReportType.onChange(option.value)
                                }}
                            />
                        </InputContainer>
                        <div className={"wrapper"} style={{display: "flex"}}>
                            <InputContainer>
                                From Data
                                <DatePickerContainer>
                                    <DatePicker
                                        {...register('fromDate', {required: true})}
                                        selected={fieldFromDate.value}
                                        onChange={(date) => fieldFromDate.onChange(date)}
                                        dateFormat={"dd/MM/yyyy"}
                                        calendarClassName="custom-calendar"
                                        maxDate={fieldToDate.value}
                                    />
                                </DatePickerContainer>
                            </InputContainer>
                            <InputContainer>
                                To Date
                                <DatePickerContainer>
                                    <DatePicker
                                        {...register('toDate', {required: true})}
                                        selected={fieldToDate.value}
                                        onChange={(date) => fieldToDate.onChange(date)}
                                        dateFormat={"dd/MM/yyyy"}
                                        calendarClassName="custom-calendar"
                                        maxDate={new Date()}
                                        minDate={fieldFromDate.value}
                                    />
                                </DatePickerContainer>
                            </InputContainer>
                        </div>
                        <Button type={"submit"}>Generate Report</Button>
                    </div>
                </form>
            </FormWrapper>
        </div>
    )

}
export default Reports;
